import styled from "styled-components";
import {
  isHtmlBlogContent,
  sanitizeBlogHtml,
} from "../../utils/blogContent";

const Block = styled.div`
  font-size: inherit;
  line-height: 1.65;
  color: inherit;

  p {
    margin: 0 0 0.75rem;
  }
  p:last-child {
    margin-bottom: 0;
  }
  ul,
  ol {
    margin: 0 0 0.75rem 1.1rem;
    padding: 0;
  }
  a {
    color: hsl(${({ theme }) => theme.colors.primary});
  }
`;

/** Renders plain text or sanitized HTML from admin Quill fields. */
export default function RichTextContent({ html, as: Tag = "div" }) {
  const text = String(html || "").trim();
  if (!text) return null;

  if (isHtmlBlogContent(text)) {
    return (
      <Block
        as={Tag}
        dangerouslySetInnerHTML={{ __html: sanitizeBlogHtml(text) }}
      />
    );
  }

  return <Block as={Tag}>{text}</Block>;
}
